
<template>
<div class="agWs">
    <b-card>
      <template slot="header">
        <span 
          class="agWs-title" 
          v-b-tooltip.hover
          :title="'Edit ' + workspace.name"
          @click="title_click">
          {{workspace.name}}
          <span v-if="isReadonly" class="danger">({{workspace.owner.username}})</span>
        </span>
        <b-dropdown 
          class="agDropdown" 
          no-caret 
          dropleft
          v-b-tooltip.hover
          title="Actions">
          <template slot="button-content">
            <fa icon="cog"/>
          </template>
          <b-dropdown-item v-if="isReadonly" href="#" @click="editWsButton_click"><fa icon="eye"/>View</b-dropdown-item>
          <b-dropdown-item v-else href="#" @click="editWsButton_click"><fa icon="pen"/>Edit</b-dropdown-item>
          <b-dropdown-item href="#" class="danger" :disabled="isReadonly" @click="deleteWsButton_click"><fa icon="ban"/>Delete</b-dropdown-item>
        </b-dropdown>
      </template>
      <label>{{workspace.description}}</label>
      <hr>
      <label class="agWs-label">Owner:</label>
      <label class="agWs-value">{{workspace.owner.username}}</label>
      <br>
      <label class="agWs-label">Groups:</label>
      <label class="agWs-value">{{groupsStr}}</label>
      <br>
      <label class="agWs-label">Users:</label>
      <label class="agWs-value">{{usersStr}}</label>
      <br>
      <label class="agWs-label">Workflows:</label>
      <label class="agWs-value">{{workflowsStr}}</label>
      <br>
      <label class="agWs-label">Connections:</label>
      <label class="agWs-value">{{connectionsStr}}</label>
    </b-card>
</div>
</template>






<script>

// components


// modules
import Server from "src/server";


export default {
    name: "ag-workspace",
    components: {

    },
    props:{
        workspace: Object
    },
    data(){
        return {
          workflows: [],
          connections: [],
        };
    },
    computed: {

      isReadonly() {
        if(this.user.role != "admin" && (this.user.role == "readonly" || this.workspace.owner._id != this.user._id))
          return true;
        return false;
      },

      user() {
        return this.$store.state.userStore.user;
      },
      
      groupsStr() {
        var str = "";
        for(var i = 0; i < this.workspace.groups.length; i++) {
          var group = this.workspace.groups[i];
          str += group.name + ", ";
        }
        str = str.substring(0, str.length - 2); // remove last ', '
        return str;
      },

      usersStr() {
        var str = "";
        for(var i = 0; i < this.workspace.users.length; i++) {
          var user = this.workspace.users[i];
          str += user.username + ", ";
        }
        str = str.substring(0, str.length - 2); // remove last ', '
        return str;
      },

      workflowsStr() {
        var str = "";
        for(var i = 0; i < this.workflows.length; i++) {
          var workflow = this.workflows[i];
          str += workflow.name + ", ";
        }
        str = str.substring(0, str.length - 2); // remove last ', '
        return str;
      },

      connectionsStr() {
        var str = "";
        for(var i = 0; i < this.connections.length; i++) {
          var connection = this.connections[i];
          str += connection.name + ", ";
        }
        str = str.substring(0, str.length - 2); // remove last ', '
        return str;
      },
    },
    watch: {
      
    },

    created() {

    },

    mounted() {
      this.setWorkflows();
      this.setConnections();
    },

    methods: {

        // UI Events

        editWsButton_click() {
            this.$emit("editWorkspace", this.workspace);
        },

        deleteWsButton_click() {
            this.$emit("deleteWorkspace", this.workspace);
        },

        title_click() {
          this.$emit("editWorkspace", this.workspace);
        },
        
 
        // emitted Events


        // other

        async setWorkflows() {
          try {
            this.workflows = [];
            var result = await Server.post("getWorkflows", { workspace: this.workspace }).promise;
            if(result.data.success)
              this.workflows = result.data.workflows;
          }
          catch(e) {
            console.log("Failed 'getWorkflows' server call. " + e.toString());
          }
        },

        async setConnections() {
          try {
            this.connections = [];
            var result = await Server.post("getConnections", { workspace: this.workspace }).promise;
            if(result.data.success)
              this.connections = result.data.connections;
          }
          catch(e) {
            console.log("Failed 'getConnections' server call. " + e.toString());
          }
        },
    }
}

</script>






<style scoped lang="css">

.agWs {
  margin-bottom: 25px;
}

.agWs-ghost .card {
  background-color: rgba(0, 0, 0, 0.15);
}

.agWs .card {
  height: 100%;
  text-align: left;
}

.agWs .card-header {
  color: #4A797C;
  font-weight: bold;
  font-size: 18px;
  cursor: grab;
}

.agWs .card-header:active {
  cursor: grabbing;
}

.agWs-title {
    cursor: pointer;
}

.agWs-title:hover {
  opacity: 0.5;
}

.agWs .agDropdown {
  float: right;
}

.agWs-label {
  width: 125px;
  font-weight: bold;
}

.agWs .agToggle
{
  float: right;
}


</style>



// WEBPACK FOOTER //
// src/components/workspace/Workspace.vue